import { z } from 'zod'
import { FamilySchema } from '../family.js'
import { ContractSchema } from '../contract.js'
import { RecommendationSchema } from '../recommendation.js'
import { ZoneStateSchema } from '../zone.js'

export const FamilyResponseSchema = FamilySchema
export type FamilyResponse = z.infer<typeof FamilyResponseSchema>

export const FamilyAtlasResponseSchema = z.object({
  family: FamilySchema,
  contracts: z.array(ContractSchema),
  zones: z.array(ZoneStateSchema),
  recommendations: z.array(RecommendationSchema),
})
export type FamilyAtlasResponse = z.infer<typeof FamilyAtlasResponseSchema>
